const GENERIC_CLIENT_ERROR_MESSAGE = 'An error has occurred';

/** Log a client-side failure without exposing error details in production (CWE-209). */
export function logClientError(context: string, error?: unknown): void {
  console.error(GENERIC_CLIENT_ERROR_MESSAGE);
  if (process.env.NODE_ENV === 'development') {
    console.debug(`[${context}]`, error);
  }
}
